import EnterpriseExperiments from 'bundles/epic/clients/Enterprise';

export { generateImpressionForMinm2Licenses, getMinLicenseCount, previewMinm2Licenses } from '@coursera-web/wes-common';

export {
  generateImpressionForDifferentialPricing,
  previewImpressionForDifferentialPricing,
  generateImpressionForSelfServeInvoicing,
  previewImpressionForSelfServeInvoicing,
} from '@coursera-web/wes-common';

// WES Payment Gateway - BT/Stripe
export const generateImpressionForPg = () => EnterpriseExperiments.get('paymentGatewayDisplayed');
export const isStripeEnabled = () => EnterpriseExperiments.preview('paymentGatewayDisplayed') === 'stripeEnterpriseWes';

/**
 * This is a feature gate for tiered pricing not an experiment. Will be cleaned up before launch.
 * @returns
 */
export const previewTieredPricingEnabled = () => EnterpriseExperiments.preview('tieredPricingEnabled');
